/**
 * 에러 페이지 컴포넌트
 * 문의접수, 새로고침 버튼 제공
 */
import { Button } from "components/ui/Button";
import { fn_cs_pop } from "function/FnBodySetting";
import errorImg from "static-file/images/icon_errorboundary.svg";
import VoCsView from "views/main/body/layer/VoCsView";
import VoCsAgreeView from "views/main/body/layer/VoCsAgreeView";
import AlertView from "views/main/body/layer/AlertView";
export const ErrorFallback = ({ rootStore }: { rootStore: any }) => {

    // 새로고침
  const handleReload = () => {
    window.location.reload();
  };

  // 문의접수
  const handleCs = () => {
    fn_cs_pop(rootStore);
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center h-screen gap-8">
        <div className="flex flex-col items-center gap-4">
          <img src={errorImg} alt="error" width={100} height={100} />
          <h2 className="text-2xl">
            <b>일시적인 오류가 발생</b>하였습니다.
          </h2>
        </div>
        <p className="text-base text-center">
          서비스 이용에 불편을 드려 죄송합니다.
          <br />
          새로고침 후 문제가 지속되면 문의접수를 통해 문의해주세요.
        </p>
        <div className="flex gap-2 w-96">
          <Button variant="default" fullWidth onClick={handleCs}>
            문의접수
          </Button>
          <Button variant="primary" fullWidth onClick={handleReload}>
            새로고침
          </Button>
        </div>
      </div>
      {rootStore && (
        <>
          <VoCsView rootStore={rootStore} />
          <VoCsAgreeView rootStore={rootStore} />
          <AlertView rootStore={rootStore} />
        </>
      )}
    </>
  );
};
